import { Messages } from '../../../../../../gen-src/Localize';
import { FieldIcon } from '../types/FieldIcon';

export const FieldNameMappings: Record<FieldIcon, () => string> = {
  Bool: Messages.FieldBool,
  BoolCalc: Messages.FieldBoolCalc,

  DateCalcContinuous: Messages.FieldDateCalcContinuous,
  DateCalcDiscrete: Messages.FieldDateCalcDiscrete,
  DateContinuous: Messages.FieldDateContinuous,
  DateDiscrete: Messages.FieldDateDiscrete,

  DateTimeCalcContinuous: Messages.FieldDateTimeCalcContinuous,
  DateTimeCalcDiscrete: Messages.FieldDateTimeCalcDiscrete,
  DateTimeContinuous: Messages.FieldDateTimeContinuous,
  DateTimeDiscrete: Messages.FieldDateTimeDiscrete,

  GeoCalcContinuous: Messages.FieldGeoCalcContinuous,
  GeoCalcDiscrete: Messages.FieldGeoCalcDiscrete,
  GeoContinuous: Messages.FieldGeoContinuous,
  GeoDiscrete: Messages.FieldGeoDiscrete,

  Group: Messages.FieldGroup,
  GroupGeo: Messages.FieldGroupGeo,

  Hierarchy: Messages.FieldHierarchy,

  NumberCalcContinuous: Messages.FieldNumberCalcContinuous,
  NumberCalcDiscrete: Messages.FieldNumberCalcDiscrete,
  NumberContinuous: Messages.FieldNumberContinuous,
  NumberDiscrete: Messages.FieldNumberDiscrete,

  NumericBinDiscrete: Messages.FieldNumericBinDiscrete,
  NumericBinContinuous: Messages.FieldNumericBinContinuous,

  Set: Messages.FieldSet,

  TextCalcContinuous: Messages.FieldTextCalcContinuous,
  TextCalcDiscrete: Messages.FieldTextCalcDiscrete,
  TextContinuous: Messages.FieldTextContinuous,
  TextDiscrete: Messages.FieldTextDiscrete,

  Unknown: Messages.FieldUnknown
};
